
import Grid2 from "../../../assets/duotone/Grid2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Grid2Icon({ className, dataTestid = "Grid2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Grid2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
